// 공용 버튼 — ECHO 톤
// 기존 화면들이 넘기던 레거시 색상(#2D2D2D 등)을 새 톤으로 자동 변환해서
// 화면 파일을 안 고쳐도 전체 버튼이 새 디자인이 됩니다.

const BG_MAP = {
  "#2D2D2D": "#0E141B", // 검정 → 잉크
  "#2d2d2d": "#0E141B",
  "#000000": "#0E141B",
  "#000": "#0E141B",
  "#F6F8FA": "#F4F8F7", // 연회색 → 세이지
  "#f6f8fa": "#F4F8F7",
  "#11346A": "#0E141B", // 남색 → 잉크
  "#11346a": "#0E141B",
};

const normalizeBg = (bg) => (bg && BG_MAP[bg]) || bg;
const normalizeBorder = (border) => {
  if (!border || border === "none") return "none";
  // "1px solid #000000" 같은 레거시 테두리 → 새 톤
  if (border.includes("#000")) return "1.5px solid #0E141B";
  if (border.includes("#EBEBEB") || border.includes("#ebebeb"))
    return "1.5px solid #E6EDEC";
  return border;
};

export const Button = ({
  children,
  onClick,
  backgroundColor,
  color,
  border,
  fontSize = "0.88rem",
  padding = "8px 18px",
}) => (
  <button
    style={{
      backgroundColor: normalizeBg(backgroundColor),
      color: color === "#000000" || color === "#000" ? "#0E141B" : color,
      padding: padding,
      border: normalizeBorder(border),
      borderRadius: "999px",
      cursor: "pointer",
      fontSize: fontSize,
      fontWeight: 700,
      fontFamily: "inherit",
      transition: "opacity .12s, background-color .12s",
      whiteSpace: "nowrap",
    }}
    onClick={onClick}
    onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
  >
    {children}
  </button>
);
